/* Kyckr V2 coverage, generated from Kyckr's 'V2 Data mappings June 2026' matrix
 * (supplied 10/08/26). What each product actually returns per jurisdiction.
 * Used to state coverage as FACT before a credit is spent, and to distinguish
 * 'this register does not publish it' from 'the client concealed it'.
 * enhanced === null means Enhanced Profile is not offered for that jurisdiction. */
export const KYCKR_COVERAGE = [
{
"name": "ALABAMA (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": true,
"shareholders": false,
"ubos": false
}
},
{
"name": "ALASKA (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "ALBERTA (CA)",
"iso": null,
"lite": true,
"enhanced": null
},
{
"name": "ARIZONA (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "AUSTRALIA",
"iso": "AU",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": true,
"ubos": false
}
},
{
"name": "AUSTRIA",
"iso": "AT",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": true,
"ubos": false
}
},
{
"name": "BAHRAIN",
"iso": "BH",
"lite": true,
"enhanced": null
},
{
"name": "BELGIUM",
"iso": "BE",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": true,
"ubos": false
}
},
{
"name": "BRAZIL",
"iso": "BR",
"lite": true,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "BRITISH COLUMBIA (CA)",
"iso": null,
"lite": true,
"enhanced": null
},
{
"name": "CALIFORNIA (US)",
"iso": null,
"lite": false,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "CAMBODIA",
"iso": "KH",
"lite": true,
"enhanced": null
},
{
"name": "CHINA",
"iso": "CN",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": true,
"ubos": false
}
},
{
"name": "COLOMBIA",
"iso": "CO",
"lite": true,
"enhanced": null
},
{
"name": "COLORADO (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "CONNECTICUT (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": true,
"shareholders": false,
"ubos": false
}
},
{
"name": "CROATIA",
"iso": "HR",
"lite": true,
"enhanced": null
},
{
"name": "CURACAO",
"iso": "CW",
"lite": true,
"enhanced": null
},
{
"name": "CYPRUS",
"iso": "CY",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": false,
"ubos": false
}
},
{
"name": "CZECH REPUBLIC",
"iso": "CZ",
"lite": true,
"enhanced": null
},
{
"name": "DELAWARE (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "DENMARK",
"iso": "DK",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": true,
"ubos": false
}
},
{
"name": "DOMINICAN REPUBLIC",
"iso": "DO",
"lite": true,
"enhanced": null
},
{
"name": "ESTONIA",
"iso": "EE",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": true,
"ubos": false
}
},
{
"name": "FEDERAL (CA)",
"iso": null,
"lite": true,
"enhanced": null
},
{
"name": "FINLAND",
"iso": "FI",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": false,
"ubos": false
}
},
{
"name": "FLORIDA (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": true,
"shareholders": false,
"ubos": false
}
},
{
"name": "FRANCE",
"iso": "FR",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": true,
"ubos": false
}
},
{
"name": "GEORGIA",
"iso": "GE",
"lite": true,
"enhanced": null
},
{
"name": "GERMANY",
"iso": "DE",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": true,
"ubos": false
}
},
{
"name": "GIBRALTAR",
"iso": "GI",
"lite": true,
"enhanced": null
},
{
"name": "GREECE",
"iso": "GR",
"lite": false,
"enhanced": {
"officers": false,
"shareholders": true,
"ubos": false
}
},
{
"name": "GUERNSEY",
"iso": "GG",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": false,
"ubos": false
}
},
{
"name": "HONG KONG",
"iso": "HK",
"lite": true,
"enhanced": null
},
{
"name": "ICELAND",
"iso": "IS",
"lite": true,
"enhanced": null
},
{
"name": "IDAHO (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "INDIANA (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "IOWA (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "IRELAND",
"iso": "IE",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": true,
"ubos": false
}
},
{
"name": "ISLE OF MAN",
"iso": "IM",
"lite": true,
"enhanced": null
},
{
"name": "ISRAEL",
"iso": "IL",
"lite": true,
"enhanced": null
},
{
"name": "ITALY",
"iso": "IT",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": true,
"ubos": false
}
},
{
"name": "JAPAN",
"iso": "JP",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": true,
"ubos": false
}
},
{
"name": "JERSEY",
"iso": "JE",
"lite": true,
"enhanced": null
},
{
"name": "KENTUCKY (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": true,
"shareholders": false,
"ubos": false
}
},
{
"name": "LATVIA",
"iso": "LV",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": true,
"ubos": false
}
},
{
"name": "LIECHTENSTEIN",
"iso": "LI",
"lite": true,
"enhanced": null
},
{
"name": "LITHUANIA",
"iso": "LT",
"lite": true,
"enhanced": null
},
{
"name": "LUXEMBOURG",
"iso": "LU",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": true,
"ubos": false
}
},
{
"name": "MAINE (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "MALAYSIA",
"iso": "MY",
"lite": true,
"enhanced": {
"officers": false,
"shareholders": true,
"ubos": false
}
},
{
"name": "MANITOBA (CA)",
"iso": null,
"lite": true,
"enhanced": null
},
{
"name": "MARSHALL ISLANDS",
"iso": "MH",
"lite": true,
"enhanced": null
},
{
"name": "MASSACHUSETTS (US)",
"iso": null,
"lite": false,
"enhanced": {
"officers": true,
"shareholders": false,
"ubos": false
}
},
{
"name": "MINNESOTA (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": true,
"shareholders": false,
"ubos": false
}
},
{
"name": "MONTENEGRO",
"iso": "ME",
"lite": true,
"enhanced": null
},
{
"name": "NETHERLANDS",
"iso": "NL",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": true,
"ubos": false
}
},
{
"name": "NEW BRUNSWICK (CA)",
"iso": null,
"lite": true,
"enhanced": null
},
{
"name": "NEW HAMPSHIRE (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "NEW JERSEY (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "NEW MEXICO (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": true,
"shareholders": false,
"ubos": false
}
},
{
"name": "NEW YORK (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "NEW ZEALAND",
"iso": "NZ",
"lite": true,
"enhanced": {
"officers": false,
"shareholders": true,
"ubos": false
}
},
{
"name": "NEWFOUNDLAND & LABRADOR (CA)",
"iso": null,
"lite": true,
"enhanced": null
},
{
"name": "NORTH DAKOTA (US)",
"iso": null,
"lite": true,
"enhanced": null
},
{
"name": "NORWAY",
"iso": "NO",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": false,
"ubos": false
}
},
{
"name": "NOVA SCOTIA (CA)",
"iso": null,
"lite": true,
"enhanced": null
},
{
"name": "OMAN",
"iso": "OM",
"lite": true,
"enhanced": null
},
{
"name": "ONTARIO (CA)",
"iso": null,
"lite": true,
"enhanced": null
},
{
"name": "OREGON (US)",
"iso": null,
"lite": false,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "PAKISTAN",
"iso": "PK",
"lite": true,
"enhanced": null
},
{
"name": "POLAND",
"iso": "PL",
"lite": true,
"enhanced": null
},
{
"name": "PORTUGAL",
"iso": "PT",
"lite": true,
"enhanced": null
},
{
"name": "QUEBEC (CA)",
"iso": null,
"lite": true,
"enhanced": null
},
{
"name": "RHODE ISLAND (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "ROMANIA",
"iso": "RO",
"lite": true,
"enhanced": null
},
{
"name": "RUSSIA",
"iso": "RU",
"lite": true,
"enhanced": null
},
{
"name": "SASKATCHEWAN (CA)",
"iso": null,
"lite": true,
"enhanced": null
},
{
"name": "SINGAPORE",
"iso": "SG",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": true,
"ubos": false
}
},
{
"name": "SLOVAKIA",
"iso": "SK",
"lite": true,
"enhanced": null
},
{
"name": "SLOVENIA",
"iso": "SI",
"lite": true,
"enhanced": null
},
{
"name": "SOUTH CAROLINA (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "SOUTH DAKOTA (US)",
"iso": null,
"lite": true,
"enhanced": null
},
{
"name": "SPAIN",
"iso": "ES",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": false,
"ubos": false
}
},
{
"name": "SWEDEN",
"iso": "SE",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": false,
"ubos": false
}
},
{
"name": "SWITZERLAND",
"iso": "CH",
"lite": true,
"enhanced": null
},
{
"name": "TAIWAN",
"iso": "TW",
"lite": true,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "UGANDA",
"iso": "UG",
"lite": true,
"enhanced": null
},
{
"name": "UNITED KINGDOM",
"iso": "GB",
"lite": true,
"enhanced": {
"officers": true,
"shareholders": true,
"ubos": true
}
},
{
"name": "URUGUAY",
"iso": "UY",
"lite": true,
"enhanced": null
},
{
"name": "VANUATU",
"iso": "VU",
"lite": true,
"enhanced": null
},
{
"name": "WEST VIRGINIA (US)",
"iso": null,
"lite": false,
"enhanced": {
"officers": true,
"shareholders": false,
"ubos": false
}
},
{
"name": "WISCONSIN (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": false,
"shareholders": false,
"ubos": false
}
},
{
"name": "WYOMING (US)",
"iso": null,
"lite": true,
"enhanced": {
"officers": true,
"shareholders": false,
"ubos": false
}
}
];

const norm = (v) => String(v || '').trim().toUpperCase().replace(/[^A-Z ]/g, '');
const BY_ISO = {}, BY_NAME = {};
for (const e of KYCKR_COVERAGE) { if (e.iso) BY_ISO[e.iso] = e; BY_NAME[norm(e.name)] = e; }

/** Coverage for a jurisdiction, by ISO code or by name. null when unknown to the matrix. */
export function kyckrCoverage(isoOrName) {
  const v = String(isoOrName || '').trim();
  if (!v) return null;
  if (v.length === 2 && BY_ISO[v.toUpperCase()]) return BY_ISO[v.toUpperCase()];
  return BY_NAME[norm(v)] || null;
}

/** US and Canadian coverage is per state or province, not per country: the
 * matrix lists individual registers and has no national row, so a lookup by
 * 'US' or 'CA' must say which registers are covered rather than nothing. */
const SUBNATIONAL = { US: '(US)', CA: '(CA)' };
function subnationalNote(code) {
  const suffix = SUBNATIONAL[code];
  if (!suffix) return null;
  const rows = KYCKR_COVERAGE.filter(e => e.name.endsWith(suffix));
  if (!rows.length) return null;
  const enh = rows.filter(e => e.enhanced).map(e => e.name.replace(' ' + suffix, ''));
  const liteOnly = rows.filter(e => !e.enhanced).map(e => e.name.replace(' ' + suffix, ''));
  const label = code === 'US' ? 'the United States' : 'Canada';
  let out = `Coverage in ${label} is per state or province register, not national. Enter the specific register in the country box to see its coverage.`;
  if (enh.length) out += ` Enhanced Profile available for: ${enh.join(', ')}.`;
  if (liteOnly.length) out += ` Lite Profile only for: ${liteOnly.join(', ')}.`;
  return out + ' A fact about the coverage, not a finding about the client.';
}

/** Plain sentence for the officer: what this jurisdiction's Enhanced check will return. */
export function kyckrCoverageNote(isoOrName) {
  const sub = subnationalNote(String(isoOrName || '').trim().toUpperCase());
  if (sub) return sub;
  const c = kyckrCoverage(isoOrName);
  if (!c) return null;
  if (!c.enhanced) return `Kyckr does not offer an Enhanced Profile for ${c.name}. Only the Lite Profile (company identity and status) is available, so officers, shareholdings and beneficial ownership cannot be cross-checked at the register through Kyckr for this jurisdiction. A fact about the coverage, not a finding about the client.`;
  const have = [], lack = [];
  ({ officers: 'officers', shareholders: 'shareholdings', ubos: 'beneficial ownership' });
  for (const [k, label] of [['officers', 'officers'], ['shareholders', 'shareholdings'], ['ubos', 'beneficial ownership']]) (c.enhanced[k] ? have : lack).push(label);
  let s = `Enhanced Profile coverage for ${c.name}: returns ${have.length ? have.join(', ') : 'company identity only'}.`;
  if (lack.length) s += ` Does not return ${lack.join(', ')}, so an empty section there is a fact about the coverage, not a finding about the client.`;
  return s;
}

/** True where Kyckr publishes no Enhanced Profile at all for the jurisdiction. */
export function kyckrEnhancedUnavailable(isoOrName) {
  const c = kyckrCoverage(isoOrName);
  return !!(c && !c.enhanced);
}
